import React from 'react'
import Head from 'next/head'

import useSchoolContext from 'app/KinerjaKSPage/hooks/useSchoolContext'
import EvaluationResult from 'app/KinerjaKSPage/components/EvaluationResult'
import useEvaluationResult from 'app/KinerjaKSPage/hooks/useEvaluationResult'

const HasilEvaluasi = ({}) => {
  const { currentNpsn } = useSchoolContext()

  const { isLoading, isSuccess, isError, isFinal, result, mappedResult, meta } =
    useEvaluationResult({ npsn: currentNpsn })

  const periodYear = meta?.skpYear || 2024
  const periodNo = meta?.skpPeriod || 1

  const title = `Dokumen Evaluasi Kinerja Periode ${periodNo} Tahun ${periodYear}`

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <EvaluationResult.Root>
        <EvaluationResult.Header title={title} />

        {/* Holds the "Terima kasih sudah menyelesaikan periode ini!" banner */}
        {isSuccess && isFinal && <EvaluationResult.BannerDinas />}

        <EvaluationResult.Content>
          {isLoading && <EvaluationResult.Spinner />}

          {isError && <EvaluationResult.Error />}

          {isSuccess && (
            <EvaluationResult.Result.Root>
              {/* Holds the Header */}
              <EvaluationResult.Result.Header title={title} />

              <EvaluationResult.Result.Content>
                {/* Holds the "Nama Instansi" and "Periode Penilaian" */}
                <EvaluationResult.Result.Info name={result?.namaInstansi} />

                {/* Holds the "Pegawai yang Dinilai" and "Pejabat Penilai Kinerja" */}
                <EvaluationResult.Result.Details data={mappedResult?.details} />

                {/* Holds the "Predikat Kinerja", "Poin Pengembangan Kompetensi", and footnote */}
                <EvaluationResult.Result.Summary
                  className="mt-3"
                  data={{
                    predicates: mappedResult?.predicates,
                    summary: mappedResult?.summary,
                  }}
                />
              </EvaluationResult.Result.Content>
            </EvaluationResult.Result.Root>
          )}
        </EvaluationResult.Content>
      </EvaluationResult.Root>
    </>
  )
}

export default HasilEvaluasi
